import { useTranslation } from "context/LanguageContext";

export default function PackageTrackingLink({ packageId }) {
  const { t } = useTranslation();

  if (packageId === undefined || packageId === null || String(packageId).trim() === "") {
    return null;
  }

  const trackingUrl = `https://ultra-pal.com/package/${encodeURIComponent(String(packageId).trim())}`;

  return (
    <a
      href={trackingUrl}
      target="_blank"
      rel="noopener noreferrer"
      className="inline-flex items-center font-semibold text-blue-600 hover:text-blue-700 hover:underline transition-colors"
    >
      {t("trackPackage")}
    </a>
  );
}
